import React, { useState } from "react";
import { format } from "date-fns";
import Icon from "../../fontIcons/icon";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import { Typography, useTheme, withStyles } from "@material-ui/core";
import { AnimatePresence, motion } from "framer-motion";
import { useQuery } from "react-query";
import "./index.css";
import { ImportExport } from "@material-ui/icons";
import { FiSend } from "react-icons/fi";
import { BsArrowDown } from "react-icons/bs";
import { useHistory } from "react-router";
import fetcher from "../../api/swr_fetcher";
import { isFirefox } from "react-device-detect";
import { useSelector } from "react-redux";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button } from "@material-ui/core";
import { set } from "lodash";
const AccordionSummary = withStyles((theme) => ({
  root: {
    backgroundColor: (props) =>
      props.expanded
        ? theme.palette.type == "dark"
          ? "#141C2E"
          : "#fff"
        : theme.palette.type == "dark"
        ? "#141828"
        : "#eee",
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
}))(MuiAccordionSummary);

const Accordion = withStyles((theme) => ({
  root: {
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    backgroundColor: theme.palette.type == "dark" ? "#141C2E" : "#fff",

    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
}))(MuiAccordion);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

export default function WalletCard(props) {
  const theme = useTheme();
  let history = useHistory();
  const [userOpen, setUserOpen] = useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const [message, setMessage] = useState({ title: "", content: "" });
  const darkMode = useSelector((state) => state.trading.DARK_MODE);
  const handleChange = () => {
    setExpanded(!expanded);
  };
  function addZeroes(num) {
    return num.toLocaleString("en", {
      useGrouping: false,
      minimumFractionDigits: 2,
    });
  }
  const userConfig = useQuery(["userconfig"], async () => {
    return await fetcher("/v1/userConfigs");
  });

  function handleClose() {
    setUserOpen(false);
  }

  function handleClickOpen(message) {
    setMessage(message);
    setUserOpen(true);
  }
  return (
    <div>
      <Accordion
        square
        expanded={expanded}
        onChange={handleChange}
        className={`overflow-hidden ${props.rounded}`}
      >
        <AccordionSummary
          aria-controls="panel1d-content"
          id="panel1d-header"
          className="overflow-hidden"
          expanded={expanded}
        >
          <div className="flex justify-between w-full">
            <motion.div
              animate={
                !expanded ? { x: 0, opacity: 1 } : { x: "calc(100% — 50%)" }
              }
              transition={{
                type: "tween",
                stiffness: 100,
              }}
              className="flex items-center w-full"
            >
              {/* <Icon
                className="mr-3"
                icon={props.coin.coinId.toLowerCase()}
                size={28}
                color={props.coin.icon?.color}
              /> */}
              <img
                src={props.coinIcons.activeIconUrl}
                height="auto"
                width={24}
                className="mr-3"
                alt={props.coin.coinId}
              />
              <div className="">
                <motion.h4
                  animate={!expanded ? "initial" : { y: 10 }}
                  transition={{
                    type: "tween",
                    stiffness: 100,
                    duration: 0.4,
                  }}
                >
                  {props.coin.icon?.name || props.coin.coinId}
                </motion.h4>
                <motion.h4
                  animate={!expanded ? "initial" : { y: 1000, opacity: 0 }}
                  transition={{
                    type: "tween",
                    stiffness: 100,
                    duration: 0.4,
                  }}
                  className="font-light"
                >
                  {props.coin.coinId}
                </motion.h4>
              </div>
            </motion.div>
            <div className="flex items-center">
              <motion.p
                className="mr-3 whitespace-nowrap"
                animate={!expanded ? "initial" : { y: 1000, opacity: 0 }}
                transition={{
                  type: "tween",
                  stiffness: 100,
                  duration: 0.4,
                }}
              >
                {addZeroes(Number(props.coin.availableBalance))}{" "}
                {props.coin.coinId}
              </motion.p>{" "}
              <div
                className={`text-pb-primary-100 text-[8px] ${
                  expanded ? "rotate" : "revert"
                }`}
              >
                ▼
              </div>
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <div className="w-full  px-2">
            <motion.div
              className="flex justify-between w-full"
              initial={{ y: 100, opacity: 0 }}
              animate={!expanded ? "initial" : { y: 0, opacity: 1 }}
              transition={{
                type: "tween",
                stiffness: 100,
                duration: 0.4,
              }}
            >
              <div>
                <p className="text-gray-400 text-xs">Available</p>
                <p>{addZeroes(Number(props.coin.availableBalance))} </p>
              </div>{" "}
              <div className="text-left">
                <p className="text-gray-400 text-xs">In order</p>
                <p>
                  {Number(
                    Number(props.coin.inOrderBalance).toFixed(
                      props.config?.decimalWithdraw
                    )
                  )}{" "}
                </p>
              </div>{" "}
              <div className="text-left">
                <p className="text-gray-400 text-xs">In vault</p>
                <p>{Number(props.coin.inVaultBalance)} </p>
              </div>
              <div className="text-right">
                <p className="text-gray-400 text-xs">Total</p>
                <p>
                  {Number(
                    Number(
                      Number(props.coin.availableBalance) +
                        Number(props.coin.inOrderBalance)
                    ).toFixed(props.config?.decimalWithdraw)
                  )}{" "}
                  {props.coin.coinId}
                </p>
              </div>
            </motion.div>
            <motion.div
              className="flex justify-center w-full mt-8 mb-5 items-end"
              initial={{ y: 100, opacity: 0 }}
              animate={!expanded ? "initial" : { y: 0, opacity: 1 }}
              transition={{
                type: "tween",
                stiffness: 100,
                duration: 0.4,
              }}
            >
              <div
                className="flex flex-col text-center  mr-12"
                onClick={() => {
                  if (
                    props.config?.tradeStatus === "ACTIVE" &&
                    userConfig.data?.ct
                  ) {
                    history.push(`/trade/${props.coin.coinId}`);
                  } else {
                    (props.config?.tradeStatus === "PAUSED" ||
                      props.config?.tradeStatus === "INACTIVE") &&
                    userConfig.data?.ct
                      ? props.handleClickOpen({
                          title:
                            props.config?.tradeStatus === "PAUSED"
                              ? "Trades Paused"
                              : "Trades Disabled",
                          content:
                            props.config?.tradeStatus === "PAUSED"
                              ? `Trades for ${props.coin.coinId} are temporarily on hold. Please check back later.`
                              : `Trades for ${props.coin.coinId} are disabled.`,
                        })
                      : handleClickOpen({
                          title: "Trades are Disabled",

                          content:
                            "Trades are disabled on your account, kindly contact support for more details",
                        });
                  }
                }}
                style={{
                  color:
                    props.config?.tradeStatus == "ACTIVE" && userConfig.data?.ct
                      ? theme.palette.type === "dark"
                        ? "#c5c5c5"
                        : "#7b7b7b"
                      : "#7b7b7b",
                }}
              >
                <div className="text-[30px]">
                  <ImportExport />
                </div>
                <p className="text-xs">Trade</p>
              </div>
              <div
                className="flex flex-col text-center justify-end mr-12"
                onClick={() => {
                  if (
                    props.config?.withdrawStatus === "ACTIVE" &&
                    userConfig.data?.cw
                  ) {
                    history.push(
                      `/wallet/crypto/withdraw?coin=${props.coin.coinId}`
                    );
                  } else {
                    (props.config?.withdrawStatus === "PAUSED" ||
                      props.config?.withdrawStatus === "INACTIVE") &&
                    userConfig.data?.cw
                      ? props.handleClickOpen({
                          title:
                            props.config?.withdrawStatus === "PAUSED"
                              ? "Withdrawals Paused"
                              : "Withdrawals Disabled",
                          content:
                            props.config?.withdrawStatus === "PAUSED"
                              ? `Withdrawals for ${props.coin.coinId} are temporarily on hold. Please check back later.`
                              : `Withdrawals for ${props.coin.coinId} are disabled.`,
                        })
                      : handleClickOpen({
                          title: "Sending Crypto to other wallets is paused.",

                          content:
                            "Crypto Transfers to other wallets/exchanges have been temporarily paused while we seek regulatory clarity on compliance requirements from the relevant authorities.",
                          note: "Kindly note that INR transfers are available on the INR wallet page.",
                        });
                  }
                }}
                style={{
                  color:
                    props.config?.withdrawStatus == "ACTIVE" &&
                    userConfig.data?.cw
                      ? theme.palette.type === "dark"
                        ? "#c5c5c5"
                        : "#7b7b7b"
                      : "#7b7b7b",
                }}
              >
                <div className="text-[20px]">
                  <FiSend></FiSend>
                </div>
                <p className="text-xs">Send</p>
              </div>
              <div
                className="flex flex-col text-center"
                onClick={() => {
                  if (
                    props.config?.depositStatus === "ACTIVE" &&
                    userConfig.data?.cd
                  ) {
                    history.push(
                      `/wallet/crypto/deposit?coin=${props.coin.coinId}`
                    );
                  } else {
                    (props.config?.depositStatus === "PAUSED" ||
                      props.config?.depositStatus === "INACTIVE") &&
                    userConfig.data?.cd
                      ? props.handleClickOpen({
                          title:
                            props.config?.depositStatus === "PAUSED"
                              ? "Deposits Paused"
                              : "Deposits Disabled",
                          content:
                            props.config?.depositStatus === "PAUSED"
                              ? `Deposits for ${props.coin.coinId} are temporarily on hold. Please check back later.`
                              : `Deposits for ${props.coin.coinId} are disabled.`,
                        })
                      : handleClickOpen({
                          title:
                            "Receiving Crypto from other wallets is paused.",

                          content:
                            "Crypto Transfers from other wallets/exchanges have been temporarily paused while we seek regulatory clarity on compliance requirements from the relevant authorities ",
                          note: "Kindly note that INR transfers are available on the INR wallet page.",
                        });
                  }
                }}
                style={{
                  color:
                    props.config?.depositStatus == "ACTIVE" &&
                    userConfig.data?.cd
                      ? theme.palette.type === "dark"
                        ? "#c5c5c5"
                        : "#7b7b7b"
                      : "#7b7b7b",
                }}
              >
                <div className="text-[25px]">
                  <BsArrowDown></BsArrowDown>
                </div>
                <p className="text-xs">Receive</p>
              </div>
            </motion.div>
          </div>
        </AccordionDetails>
      </Accordion>
      <Dialog
        open={userOpen}
        onClose={handleClose}
        PaperProps={{
          style: {
            ...(!isFirefox && {
              background: darkMode
                ? "rgba(255, 255, 255, 0.1)"
                : "rgba(0, 0, 0, 0.3)",
              backdropFilter: darkMode ? "blur(20px)" : "blur(10px)",
              WebkitBackdropFilter: darkMode ? "blur(20px)" : "blur(10px)",
              borderRadius: "16px",
            }),
          },
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          className="text-base w-[340px]  max-w-[340px]  font-medium text-[#36BCA2]"
          id="alert-dialog-title"
        >
          {message.title}
        </DialogTitle>
        <DialogContent className="w-[340px] h-[250px] max-w-[340px]">
          <DialogContentText
            className="text-sm font-normal leading-8"
            id="alert-dialog-description"
          >
            {message.content}
          </DialogContentText>
          <DialogContentText
            className="text-sm font-normal leading-8"
            id="alert-dialog-description"
          >
            {message.note}
          </DialogContentText>
        </DialogContent>
        <DialogActions className="flex justify-center">
          <Button
            onClick={handleClose}
            color="primary"
            variant="contained"
            style={{
              color: "white",
              fontWeight: "bold",
              marginRight: "17px",
              marginBottom: "12px",
            }}
            className="w-[197px] rounded-sm h-[37px]"
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    </div>
    // <div className="bg-gray-300 dark:bg-gray-900 p-5">
    //   <div className="flex justify-between"></div>
    // </div>
  );
}
